import React from 'react';

import cn from 'classnames';

import ButtonBase, { ButtonBaseProps } from './ButtonBase';

interface OutlinedButtonProps extends Omit<ButtonBaseProps, 'className'> {
  variant: 'primary' | 'danger';
  isProtected?: boolean;
}

export const mapOutlinedVariant = {
  primary: `sp-btn-action-outline`,
  danger: `sp-btn-action-outline-danger`,
};

const OutlineButton = ({
  variant,
  children,
  isProtected,
  ...restProps
}: OutlinedButtonProps) => {
  return (
    <ButtonBase
      {...restProps}
      className={cn(`shadow-xs border`, mapOutlinedVariant[variant])}
      protectedVariant={isProtected ? 'outline' : undefined}
    >
      {children}
    </ButtonBase>
  );
};

export default OutlineButton;
